import { AudioEffect } from "types/AudioEffect";
import { PlaylistClip } from "types/Clip";
import { Asset } from "types/Asset";
import { EnhancedLogger } from "utilities/Logger";

export class UnmixedEffect extends AudioEffect {
  private readonly passthrough: GainNode;

  static override canBuildFor(clip: PlaylistClip): boolean {
    return true;
  }

  static override canUseLocalAsset(): boolean {
    return true;
  }

  static override providePermanentUrl(
    clip: PlaylistClip,
    asset: Asset
  ): string | undefined {
    return asset.url;
  }

  constructor(
    audioContext: AudioContext,
    clip: PlaylistClip,
    playlistTime: number,
    logger?: EnhancedLogger
  ) {
    super(audioContext, clip, playlistTime, logger);
    this.passthrough = this.audioContext.createGain();
  }

  hotswap(newClip: PlaylistClip): void {}

  disconnect(): void {
    this.passthrough.disconnect();
  }

  get inputNode(): AudioNode {
    return this.passthrough;
  }

  get outputNode(): AudioNode {
    return this.passthrough;
  }
}
